import { SURFACES } from "./pipelineColors";
import { PIPELINE } from "./pipelineGeometry";

interface Segment {
  lane: string;
  /** The lane's own colour, from the route. Not a lookup. */
  color: string;
  count: number;
}

interface Props {
  x: number;
  y: number;
  total: number;
  segments: Segment[];
}

export function InputPanel({ x, y, total, segments }: Props) {
  const totalH = PIPELINE.inputBarHeight;
  const denominator = total || 1;
  let offset = 0;

  return (
    <g transform={`translate(${x}, ${y})`}>
      <text x={34} y={12}
        fontFamily="Inter, -apple-system, sans-serif"
        fontSize={19} fontWeight={500} fill="#e2e4ea"
        textAnchor="middle"
      >{total}</text>
      <text x={34} y={24}
        fontFamily="Inter, -apple-system, sans-serif"
        fontSize={9} fill="#666a7f" textAnchor="middle"
      >30d</text>

      <rect x={PIPELINE.inputBarX} y={PIPELINE.inputBarTopY}
        width={PIPELINE.inputBarWidth} height={totalH}
        fill={SURFACES.track} rx={2}
      />
      {segments.map((seg) => {
        const h = Math.round((seg.count / denominator) * totalH);
        const showLabel = h >= 12;
        const block = (
          <g key={seg.lane}>
            <rect
              x={PIPELINE.inputBarX}
              y={PIPELINE.inputBarTopY + offset}
              width={PIPELINE.inputBarWidth}
              height={h}
              fill={seg.color}
            />
            {showLabel && (
              <text
                x={34}
                y={PIPELINE.inputBarTopY + offset + h / 2 + 3}
                fontFamily="Inter, -apple-system, sans-serif"
                fontSize={8} fontWeight={600} fill="#0f1117"
                textAnchor="middle"
              >
                {seg.lane.toUpperCase()} {seg.count}
              </text>
            )}
          </g>
        );
        offset += h;
        return block;
      })}
    </g>
  );
}
